import { observer } from 'mobx-react';
import { useCallback } from 'react';
import './style.scss';
import classNames from 'classnames';
import PaginationDirectionButton from './PaginationDirectionButton';
import PaginationPageButton from './PaginationPageButton';
import { generatePageItems } from './helpers';
import { PAGINATION_DIRECTION } from './types';
import { localeStore } from 'src/mobx/localesStore';
import { TPagination } from '~/types/main';

interface IPaginationProps {
  pagination: TPagination;
  className: string;
  visible: boolean;
  showPaginationInfo?: boolean;
  onChange: (page: number) => void;
}

const Pagination: React.FC<IPaginationProps> = (props: IPaginationProps): JSX.Element => {
  const {
    pagination: { currentPage, lastPage, totalRows, perPage },
    className,
    visible,
    showPaginationInfo = false,
    onChange,
  } = props;

  const handlePrev = useCallback(() => {
    onChange(currentPage - 1);
  }, [currentPage, onChange]);

  const handleNext = useCallback(() => {
    onChange(currentPage + 1);
  }, [currentPage, onChange]);

  if (!visible) {
    return <div style={{ height: 38 }}></div>;
  }

  return (
    <div className={classNames('pagination', className)}>
      <>
        <PaginationDirectionButton direction={PAGINATION_DIRECTION.PREV} disabled={currentPage <= 1} changePage={handlePrev} />
        {generatePageItems(lastPage, currentPage, 9, true).map(({ value, label, active }, i) => (
          <PaginationPageButton key={i} value={value} label={label} active={active} onClick={onChange} />
        ))}
        <PaginationDirectionButton direction={PAGINATION_DIRECTION.NEXT} disabled={currentPage >= lastPage} changePage={handleNext} />
      </>
      {showPaginationInfo && currentPage && perPage && totalRows && (
        <div className="pagination-info">
          <p className="pagination-info__text">
            {localeStore.t('number_of_entries', {
              ordinal_number_of_the_first_row_on_the_page: currentPage * perPage - perPage + 1,
              ordinal_number_of_the_last_row_on_the_page: currentPage * perPage,
              total_number_of_rows_in_the_table: totalRows,
            })}
          </p>
        </div>
      )}
    </div>
  );
};

export default observer(Pagination);
